import validate from "D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watc_8ac096e5f4f3e7d54fcf4d98c601ce0f/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watc_8ac096e5f4f3e7d54fcf4d98c601ce0f/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}